(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("beqAh", function(module, exports) {

$parcel$export(module.exports, "readingTime", function () { return $82d59f8de4186dbf$export$e0705390d0a3a181; });
const $82d59f8de4186dbf$var$i = {
    less: "less than a minute read",
    default: "min read"
}, $82d59f8de4186dbf$var$o = {
    less: "moins d'une minute de lecture",
    default: "min de lecture"
}, $82d59f8de4186dbf$var$l = {
    less: "menos de un minuto leyendo",
    default: "min de lectura"
}, $82d59f8de4186dbf$var$d = {
    less: "\u5C0F\u4E8E\u4E00\u5206\u949F",
    default: "\u5206\u949F"
}, $82d59f8de4186dbf$var$r = {
    less: "1\u5206\u672A\u6E80\u306E\u8AAD\u307F\u53D6\u308A",
    default: "\u6700\u5C0F\u8AAD\u307F\u53D6\u308A"
}, $82d59f8de4186dbf$var$c = {
    less: "weniger als eine Minute Lesezeit",
    default: "Min. Lesezeit"
}, $82d59f8de4186dbf$var$m = {
    less: "menos de um minuto de leitura",
    default: "minutos de leitura"
}, $82d59f8de4186dbf$var$f = {
    less: "bir dakikadan az okuma s\xfcresi",
    default: "dakika okuma s\xfcresi"
}, $82d59f8de4186dbf$var$p = {
    less: "timp de citire mai pu\u021Bin de un minut",
    default: "min. timp de lectur\u0103"
}, $82d59f8de4186dbf$var$g = {
    less: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F\u09C7\u09B0 \u0995\u09AE \u09B8\u09AE\u09AF\u09BC\u09C7 \u09AA\u09A1\u09BC\u09C1\u09A8",
    default: "\u09B8\u09B0\u09CD\u09AC\u09A8\u09BF\u09AE\u09CD\u09A8 \u09B8\u09AE\u09AF\u09BC\u09C7 \u09AA\u09A1\u09BC\u09C1\u09A8"
}, $82d59f8de4186dbf$var$k = {
    less: "menej ako min\xfata \u010D\xedtania",
    default: "min \u010D\xedtania"
}, $82d59f8de4186dbf$var$h = {
    less: "m\xe9n\u011B ne\u017E minuta \u010Dten\xed",
    default: "min \u010Dten\xed"
}, $82d59f8de4186dbf$var$b = {
    en: $82d59f8de4186dbf$var$i,
    fr: $82d59f8de4186dbf$var$o,
    es: $82d59f8de4186dbf$var$l,
    cn: $82d59f8de4186dbf$var$d,
    ja: $82d59f8de4186dbf$var$r,
    de: $82d59f8de4186dbf$var$c,
    "pt-br": $82d59f8de4186dbf$var$m,
    tr: $82d59f8de4186dbf$var$f,
    ro: $82d59f8de4186dbf$var$p,
    bn: $82d59f8de4186dbf$var$g,
    sk: $82d59f8de4186dbf$var$k,
    cs: $82d59f8de4186dbf$var$h
}, $82d59f8de4186dbf$export$1c2c8674a5fbafd = [
    "en",
    "fr",
    "es",
    "cn",
    "ja",
    "de",
    "pt-br",
    "tr",
    "ro",
    "bn",
    "sk",
    "cs"
], $82d59f8de4186dbf$var$L = (e)=>(e.match(/[\w|\d|\s|,|.|\u00C0-\u024F|\u4E00-\u9FA5|\u3041-\u309F]+/giu) ?? []).flatMap((s)=>s.match(/[\u4E00-\u9FA5]/gu) ?? s), $82d59f8de4186dbf$var$M = (e)=>$82d59f8de4186dbf$var$L(e).reduce((t, s)=>t + (s.trim().length ? s.trim().split(/\s+/u).length : 0), 0), $82d59f8de4186dbf$var$F = (e)=>e < 1 + Number.EPSILON, $82d59f8de4186dbf$var$j = (e, t = "en")=>$82d59f8de4186dbf$var$b[t][e ? "less" : "default"], $82d59f8de4186dbf$export$e0705390d0a3a181 = (e, t = 300, s = "en")=>{
    const u = $82d59f8de4186dbf$var$M(e), n = Math.round(u / t), a = $82d59f8de4186dbf$var$F(n);
    return {
        minutes: n,
        words: u,
        text: `${a ? "" : `${n} `}${$82d59f8de4186dbf$var$j(a, s)}`
    };
};

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    const hamburgerBtn = document.querySelector(".btn.btn-hamburger");
    const closeBtn = document.querySelector(".btn.navigationDrawer--closeBtn");
    const topNav = document.querySelector(".top-navigation");
    const drawer = document.querySelector(".navigationDrawer");
    // Open drawer → hide top nav, show drawer
    hamburgerBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.add("d-none");
        if (drawer) drawer.classList.remove("d-none");
    });
    // Close drawer → show top nav, hide drawer
    closeBtn.addEventListener("click", ()=>{
        if (topNav) topNav.classList.remove("d-none");
        if (drawer) drawer.classList.add("d-none");
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("keGoi"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("74LyI"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("cc7k8"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "staflexx.html",
                logoSrc: new URL((parcelRequire("cxpXu"))),
                title: "Staflexx"
            },
            {
                pageUrl: "trakn.html",
                logoSrc: new URL((parcelRequire("k9IUb"))),
                title: "Trakn"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("fZ5Q6"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("keGoi", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "battery-charging.ba1b1745.webp";

});

parcelRegister("74LyI", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "settings-02.d69d69bd.webp";

});

parcelRegister("cc7k8", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "life-buoy.285e728c.webp";

});

parcelRegister("cxpXu", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "Staflexx_favicon.0afb56d6.webp";

});

parcelRegister("k9IUb", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "trakn_favicon.ffb5470c.webp";

});

parcelRegister("fZ5Q6", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("4BHQ7") + "box.2a34708a.webp";

});


parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $bd2902a0c92dc786$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("4BHQ7"), JSON.parse('["4BHQ7","blog.c5208ea7.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","dHV0l","Staflexx_favicon.0afb56d6.webp","cmPFA","trakn_favicon.ffb5470c.webp","9Glg9","box.2a34708a.webp"]'));


var $beqAh = parcelRequire("beqAh");
parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("2SvjK");
// Arrow Up Icon Button
const $2ddec68544ba4d7e$var$arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".btn.contents__blog--cardReadMoreBtn").forEach((el)=>{
    el.innerHTML += $2ddec68544ba4d7e$var$arrowUpIcon;
});
const $2ddec68544ba4d7e$var$bookDemoBtn = document.querySelector(".btn.btn-book-demo");
if ($2ddec68544ba4d7e$var$bookDemoBtn) $2ddec68544ba4d7e$var$bookDemoBtn.innerHTML += $2ddec68544ba4d7e$var$arrowUpIcon;
const $2ddec68544ba4d7e$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $2ddec68544ba4d7e$var$chevronDownIcon;
});
const $2ddec68544ba4d7e$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
const $2ddec68544ba4d7e$var$hamburgerBtn = document.querySelector(".btn-hamburger");
if ($2ddec68544ba4d7e$var$hamburgerBtn) $2ddec68544ba4d7e$var$hamburgerBtn.innerHTML += $2ddec68544ba4d7e$var$hamburgerIcon;
// Environment Variable Setup
let $2ddec68544ba4d7e$var$rawStrapiUrl = "https://blogger.wenodo.com/";
$2ddec68544ba4d7e$var$rawStrapiUrl = $2ddec68544ba4d7e$var$rawStrapiUrl.replace(/\/+$/, "");
if ($2ddec68544ba4d7e$var$rawStrapiUrl.endsWith("/api")) $2ddec68544ba4d7e$var$rawStrapiUrl = $2ddec68544ba4d7e$var$rawStrapiUrl.slice(0, -4);
const $2ddec68544ba4d7e$var$STRAPI_URL = $2ddec68544ba4d7e$var$rawStrapiUrl;
const $2ddec68544ba4d7e$var$STRAPI_TOKEN = "3f50eea6cbec44e0476f34e97fff30090c4988b28db1788b6da675c93a027a09e8fd7ca8d27b453b09cdc6cb8fd1984bd7e5060cbb74508685c5159ce970c013ab43ae323b2b50681b3639734275574d44feb62a7b6f6b33467172ad56c23a74e166659691c859efc0d2a8134969cd47ff95960967e435534e4cc97205d2b397";
const $2ddec68544ba4d7e$var$BASE_URL = "https://wenodo.com/";
// Get Data Strapi
const $2ddec68544ba4d7e$var$myHeaders = new Headers();
if ($2ddec68544ba4d7e$var$STRAPI_TOKEN) $2ddec68544ba4d7e$var$myHeaders.append("Authorization", `Bearer ${$2ddec68544ba4d7e$var$STRAPI_TOKEN}`);
const $2ddec68544ba4d7e$var$requestOptions = {
    method: "GET",
    headers: $2ddec68544ba4d7e$var$myHeaders,
    redirect: "follow"
};
function $2ddec68544ba4d7e$var$resolveRichText(nodes) {
    if (!Array.isArray(nodes)) return "";
    return nodes.map((c)=>$2ddec68544ba4d7e$var$resolveRichTextNode(c)).join("");
}
function $2ddec68544ba4d7e$var$resolveRichTextNode(node) {
    if (!node) return "";
    let html = "";
    const children = Array.isArray(node.children) ? node.children.map((c)=>$2ddec68544ba4d7e$var$resolveRichTextNode(c)).join("") : "";
    switch(node.type){
        case "heading":
            html = `<h${node.level || 1}>${children}</h${node.level || 1}>`;
            break;
        case "text":
            if (node.text) {
                let tmp = node.text.replaceAll("\n", "<br />");
                if (node.bold) tmp = `<b>${tmp}</b>`;
                if (node.code) tmp = `<code>${tmp}</code>`;
                if (node.italic) tmp = `<i>${tmp}</i>`;
                if (node.strikethrough) tmp = `<s>${tmp}</s>`;
                if (node.underline) tmp = `<u>${tmp}</u>`;
                html = tmp;
            }
            break;
        case "paragraph":
            html = `<p>${children}</p>`;
            break;
        case "link":
            html = `<a href="${node.url || "#"}">${children}</a>`;
            break;
        case "list":
            switch(node.format){
                case "ordered":
                    html = `<ol>${children}</ol>`;
                    break;
                case "unordered":
                default:
                    html = `<ul>${children}</ul>`;
                    break;
            }
            break;
        case "list-item":
            html = `<li>${children}</li>`;
            break;
        case "quote":
            html = `<blockquote>${children}</blockquote>`;
            break;
        case "code":
            html = `<pre>${children}</pre>`;
            break;
        case "image":
            if (node.image?.url) html = `<img src="${node.image.url}" height="${node.image.height || ""}" width="${node.image.width || ""}" alt="${node.image.alternativeText || ""}" />`;
            break;
    }
    return html;
}
function $2ddec68544ba4d7e$var$formatTitleSlug(title) {
    if (!title) return "";
    return title.replaceAll(":", "").replaceAll(" ", "-");
}
function $2ddec68544ba4d7e$var$getCoverUrl(coverData) {
    const url = coverData?.data?.attributes?.url;
    if (!url) return "";
    return url.replace("/upload", "/upload/q_auto:eco").replace(".png", ".webp");
}
function $2ddec68544ba4d7e$var$getBlogSlug(data, id) {
    if (data?.slug) return data.slug;
    const title = data?.Title || data?.title;
    if (title) return title.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
    return id || "";
}
const $2ddec68544ba4d7e$var$featuredBlogHero = (datas)=>{
    if (!Array.isArray(datas) || datas.length === 0) return;
    const data = datas[0]?.attributes || datas[0];
    if (!data) return;
    const heroElement = document.querySelector(".hero__blog--featured");
    if (!heroElement) return;
    const titleEl = heroElement.querySelector('[data-element="hero-blog-title-featured"]');
    if (titleEl) titleEl.innerHTML = data.Title || data.title || "";
    const descEl = heroElement.querySelector('[data-element="hero-blog-desc-featured"]');
    if (descEl) descEl.innerHTML = data.Detail || data.summary || "";
    const slug = $2ddec68544ba4d7e$var$getBlogSlug(data, datas[0].id);
    const linkEl = heroElement.querySelector('[data-element="hero-blog-desc-url-link"]');
    if (linkEl) linkEl.setAttribute("onclick", `location.href = "${$2ddec68544ba4d7e$var$BASE_URL}/blog-detail.html/${slug}";`);
};
const $2ddec68544ba4d7e$var$featuredLargeBlog = (datas)=>{
    if (!Array.isArray(datas) || datas.length === 0) return;
    const data = datas[0]?.attributes || datas[0];
    if (!data) return;
    const cardElement = document.querySelector('.contents__blog--card.featuredLarge[data-element="blog-card"]');
    if (!cardElement) return;
    const slug = $2ddec68544ba4d7e$var$getBlogSlug(data, datas[0].id);
    const detailUrl = `${$2ddec68544ba4d7e$var$BASE_URL}/blog-detail.html/${slug}`;
    const linkImg = cardElement.querySelector('[data-element="url-link-image"]');
    if (linkImg) {
        linkImg.setAttribute("href", detailUrl);
        const img = linkImg.querySelector("img");
        if (img) img.src = $2ddec68544ba4d7e$var$getCoverUrl(data.cover || data.coverImage || data.ogImage);
    }
    const createdDate = cardElement.querySelector('[data-element="created-date"]');
    const pubDate = data.publishedAt || data.createdAt;
    if (createdDate && pubDate) createdDate.innerHTML = moment(pubDate).format("MMM. DD,Y");
    const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]');
    const contents = data.contents || data.content || data.Detail || data.summary;
    if (readingTimeEl && contents) {
        const textContent = typeof contents === "string" ? contents : $2ddec68544ba4d7e$var$resolveRichText(contents);
        readingTimeEl.innerHTML = (0, $beqAh.readingTime)(textContent, 300).text;
    }
    const titleEl = cardElement.querySelector('[data-element="title"]');
    if (titleEl) titleEl.innerHTML = data.Title || data.title || "";
    const descEl = cardElement.querySelector('[data-element="description"]');
    if (descEl) descEl.innerHTML = data.Detail || data.summary || "";
    const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]');
    if (readMoreLink) readMoreLink.setAttribute("href", detailUrl);
};
const $2ddec68544ba4d7e$var$featuredSmallsBlog = (datas)=>{
    if (!Array.isArray(datas)) return;
    const featuredSmalls = document.querySelector(".contents__blog--featuredSmalls");
    if (!featuredSmalls) return;
    const _datas = datas.slice(1, 4);
    _datas.forEach((_data)=>{
        const data = _data?.attributes || _data;
        if (!data) return;
        const templateCard = featuredSmalls.querySelector('[data-element="blog-card"]');
        if (!templateCard) return;
        const cardElement = templateCard.cloneNode(true);
        const slug = $2ddec68544ba4d7e$var$getBlogSlug(data, _data.id);
        const detailUrl = `${$2ddec68544ba4d7e$var$BASE_URL}/blog-detail.html/${slug}`;
        const urlLinkImg = cardElement.querySelector('[data-element="url-link-image"]');
        if (urlLinkImg) {
            urlLinkImg.setAttribute("href", detailUrl);
            const img = urlLinkImg.querySelector("img");
            if (img) img.src = $2ddec68544ba4d7e$var$getCoverUrl(data.cover || data.coverImage || data.ogImage);
        }
        const createdDate = cardElement.querySelector('[data-element="created-date"]');
        const pubDate = data.publishedAt || data.createdAt;
        if (createdDate && pubDate) createdDate.innerHTML = moment(pubDate).format("MMM. DD,Y");
        const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]');
        const contents = data.contents || data.content || data.Detail || data.summary;
        if (readingTimeEl && contents) {
            const textContent = typeof contents === "string" ? contents : $2ddec68544ba4d7e$var$resolveRichText(contents);
            readingTimeEl.innerHTML = (0, $beqAh.readingTime)(textContent, 300).text;
        }
        const titleEl = cardElement.querySelector('[data-element="title"]');
        if (titleEl) titleEl.innerHTML = data.Title || data.title || "";
        const descEl = cardElement.querySelector('[data-element="description"]');
        if (descEl) descEl.innerHTML = data.Detail || data.summary || "";
        const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]');
        if (readMoreLink) readMoreLink.setAttribute("href", detailUrl);
        featuredSmalls.appendChild(cardElement);
    });
    const cards = featuredSmalls.querySelectorAll('[data-element="blog-card"]');
    if (cards.length > 0) cards[0].remove();
};
const $2ddec68544ba4d7e$var$gridListBlogs = (datas)=>{
    if (!Array.isArray(datas)) return;
    const gridBlogs = document.querySelector(".contents__blog--cards");
    if (!gridBlogs) return;
    const _datas = datas.slice(4);
    _datas.forEach((_data)=>{
        const data = _data?.attributes || _data;
        if (!data) return;
        const templateCard = gridBlogs.querySelector('[data-element="blog-card"]');
        if (!templateCard) return;
        const cardElement = templateCard.cloneNode(true);
        const slug = $2ddec68544ba4d7e$var$getBlogSlug(data, _data.id);
        const detailUrl = `${$2ddec68544ba4d7e$var$BASE_URL}/blog-detail.html/${slug}`;
        const urlLinkImg = cardElement.querySelector('[data-element="url-link-image"]');
        if (urlLinkImg) {
            urlLinkImg.setAttribute("href", detailUrl);
            const img = urlLinkImg.querySelector("img");
            if (img) img.src = $2ddec68544ba4d7e$var$getCoverUrl(data.cover || data.coverImage || data.ogImage);
        }
        const createdDate = cardElement.querySelector('[data-element="created-date"]');
        const pubDate = data.publishedAt || data.createdAt;
        if (createdDate && pubDate) createdDate.innerHTML = moment(pubDate).format("MMM. DD,Y");
        const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]');
        const contents = data.contents || data.content || data.Detail || data.summary;
        if (readingTimeEl && contents) {
            const textContent = typeof contents === "string" ? contents : $2ddec68544ba4d7e$var$resolveRichText(contents);
            readingTimeEl.innerHTML = (0, $beqAh.readingTime)(textContent, 300).text;
        }
        const titleEl = cardElement.querySelector('[data-element="title"]');
        if (titleEl) titleEl.innerHTML = data.Title || data.title || "";
        const descEl = cardElement.querySelector('[data-element="description"]');
        if (descEl) descEl.innerHTML = data.Detail || data.summary || "";
        const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]');
        if (readMoreLink) readMoreLink.setAttribute("href", detailUrl);
        gridBlogs.appendChild(cardElement);
    });
    const cards = gridBlogs.querySelectorAll('[data-element="blog-card"]');
    if (cards.length > 0) cards[0].remove();
};
const $2ddec68544ba4d7e$var$queryString = window.location.search;
const $2ddec68544ba4d7e$var$urlParams = new URLSearchParams($2ddec68544ba4d7e$var$queryString);
const $2ddec68544ba4d7e$var$page = $2ddec68544ba4d7e$var$urlParams.get("page") ?? 1;
const $2ddec68544ba4d7e$var$category = $2ddec68544ba4d7e$var$urlParams.get("category") ?? "";
const $2ddec68544ba4d7e$var$currentCategory = $2ddec68544ba4d7e$var$category || "blog-articles";
const $2ddec68544ba4d7e$var$createElementPagination = (pagination)=>{
    if (!pagination) return;
    const blogPagination = document.querySelector('[data-element="pagination"]');
    if (!blogPagination) return;
    const paginationGroup = blogPagination.querySelector('[data-element="pagination-group"]');
    if (!paginationGroup) return;
    for(let index = 0; index < (pagination.pageCount || 0); index++){
        const templateBtn = blogPagination.querySelector('[data-element="pagination-button"]');
        if (!templateBtn) break;
        const paginationButton = templateBtn.cloneNode(true);
        paginationButton.textContent = index + 1;
        const pParams = new URLSearchParams(window.location.search);
        pParams.set("page", index + 1);
        paginationButton.setAttribute("onclick", `window.location.href="${$2ddec68544ba4d7e$var$BASE_URL}/blog.html?${pParams.toString()}#blogContent";`);
        paginationGroup.appendChild(paginationButton);
    }
    if (pagination.page > 1) {
        const leftParams = new URLSearchParams(window.location.search);
        leftParams.set("page", pagination.page - 1);
        const leftBtn = blogPagination.querySelector('[data-element="pagination-left"]');
        if (leftBtn) leftBtn.setAttribute("onclick", `window.location.href="${$2ddec68544ba4d7e$var$BASE_URL}/blog.html?${leftParams.toString()}#blogContent";`);
    }
    if (pagination.page === 1) {
        const leftBtn = blogPagination.querySelector('[data-element="pagination-left"]');
        if (leftBtn) leftBtn.classList.add("disabled");
    }
    if (pagination.page < pagination.pageCount) {
        const rightParams = new URLSearchParams(window.location.search);
        rightParams.set("page", pagination.page + 1);
        const rightBtn = blogPagination.querySelector('[data-element="pagination-right"]');
        if (rightBtn) rightBtn.setAttribute("onclick", `window.location.href="${$2ddec68544ba4d7e$var$BASE_URL}/blog.html?${rightParams.toString()}#blogContent";`);
    }
    if (pagination.page === pagination.pageCount) {
        const rightBtn = blogPagination.querySelector('[data-element="pagination-right"]');
        if (rightBtn) rightBtn.classList.add("disabled");
    }
    const buttons = blogPagination.querySelectorAll('[data-element="pagination-button"]');
    if (buttons.length > 0) buttons[0].remove();
    const activeBtn = blogPagination.querySelectorAll('[data-element="pagination-button"]')[pagination.page - 1];
    if (activeBtn) activeBtn.classList.add("active");
};
// Set active tab and attach click handlers
document.querySelectorAll('[data-element="blog-tabs"] button').forEach((el)=>{
    const tabCategory = el.getAttribute("data-element");
    if (tabCategory === $2ddec68544ba4d7e$var$currentCategory) el.classList.add("active");
    else el.classList.remove("active");
    el.addEventListener("click", ()=>{
        window.location.href = `${$2ddec68544ba4d7e$var$BASE_URL}/blog.html?category=${tabCategory}#blogContent`;
    });
});
// Query CMS API (only filter if category is specified and not the main 'blog-articles' tab)
let $2ddec68544ba4d7e$var$categoryFilterParam = "";
if ($2ddec68544ba4d7e$var$category && $2ddec68544ba4d7e$var$category !== "blog-articles") $2ddec68544ba4d7e$var$categoryFilterParam = `&search=${encodeURIComponent($2ddec68544ba4d7e$var$category)}`;
const $2ddec68544ba4d7e$var$primaryUrl = `${$2ddec68544ba4d7e$var$STRAPI_URL}/api/blogs?page=${$2ddec68544ba4d7e$var$page}&pageSize=13${$2ddec68544ba4d7e$var$categoryFilterParam}`;
fetch($2ddec68544ba4d7e$var$primaryUrl, $2ddec68544ba4d7e$var$requestOptions).then((response)=>response.ok ? response.json() : null).then((result)=>{
    if (!result?.data || result.data.length === 0) {
        const notFound = document.querySelector('[data-element="blog-not-found"]');
        if (notFound) notFound.style.display = "block";
        const paginationEl = document.querySelector('[data-element="pagination"]');
        if (paginationEl) paginationEl.style.display = "none";
    } else {
        const notFound = document.querySelector('[data-element="blog-not-found"]');
        if (notFound) notFound.style.display = "none";
        $2ddec68544ba4d7e$var$featuredBlogHero(result.data);
        $2ddec68544ba4d7e$var$featuredLargeBlog(result.data);
        $2ddec68544ba4d7e$var$featuredSmallsBlog(result.data);
        $2ddec68544ba4d7e$var$gridListBlogs(result.data);
        if (result.meta?.pagination) $2ddec68544ba4d7e$var$createElementPagination(result.meta.pagination);
        document.querySelectorAll('[data-element="blog-card"]').forEach((el)=>{
            el.style.display = "flex";
        });
        const paginationEl = document.querySelector('[data-element="pagination"]');
        if (paginationEl) paginationEl.style.display = "flex";
    }
}).catch((error)=>console.error("Error fetching blogs:", error));
// Dropdown Product
const $2ddec68544ba4d7e$var$dropdownProduct = document.querySelector('[data-element="dropdown-product"]');
if ($2ddec68544ba4d7e$var$dropdownProduct) {
    const dropdownBtn = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-btn"]');
    if (dropdownBtn) dropdownBtn.addEventListener("click", ()=>{
        const dropdownContent = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-content"]');
        const arrow = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]');
        if (dropdownContent) {
            if (dropdownContent.classList.contains("hide")) {
                dropdownContent.classList.remove("hide");
                if (arrow) arrow.style.rotate = "180deg";
            } else {
                dropdownContent.classList.add("hide");
                if (arrow) arrow.style.rotate = "0deg";
            }
        }
    });
    $2ddec68544ba4d7e$var$dropdownProduct.querySelectorAll('[data-element="dropdown-btn-item"]').forEach((elBtn)=>{
        const itemSelect = elBtn.getAttribute("data-select");
        if (itemSelect === $2ddec68544ba4d7e$var$currentCategory) {
            const textP = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-btn"] p');
            if (textP) textP.textContent = elBtn.querySelector("p")?.textContent || "";
        }
        elBtn.addEventListener("click", ()=>{
            const textSelection = elBtn.querySelector("p")?.textContent || "";
            const textP = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-btn"] p');
            if (textP) textP.textContent = textSelection;
            const dropdownContent = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-content"]');
            if (dropdownContent) dropdownContent.classList.add("hide");
            const arrow = $2ddec68544ba4d7e$var$dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]');
            if (arrow) arrow.style.rotate = "0deg";
            window.location.href = `${$2ddec68544ba4d7e$var$BASE_URL}/blog.html?category=${itemSelect}#blogContent`;
        });
    });
}

})();
//# sourceMappingURL=blog.c5208ea7.js.map
